import { type FC } from 'react'

import icon from '@/assets/images/adaptive-icon-fg.png'
import { Image, Spinner, Text, VStack } from '@/components'

export interface SplashScreenProps {
  message?: string
  withSpinner?: boolean
}

export const SplashScreen: FC<SplashScreenProps> = ({ message, withSpinner = true }) => (
  <VStack className='flex-1'>
    <VStack className='pointer-events-none absolute inset-0 flex-1 items-center justify-center'>
      <Image
        accessibilityElementsHidden
        aria-hidden
        importantForAccessibility='no-hide-descendants'
        alt='Dateability Logo'
        className='h-[200px] w-[200px]'
        contentFit='contain'
        contentPosition='center'
        source={icon}
      />
    </VStack>
    <VStack
      accessible
      accessibilityLabel={`Dateability: ${message ?? 'Loading...'}`}
      className='pb-safe-or-4 flex-1 items-center justify-end gap-2 p-4'
    >
      {withSpinner && (
        <Spinner
          accessibilityElementsHidden
          aria-hidden
          importantForAccessibility='no-hide-descendants'
          className='color-white/75'
          size='large'
        />
      )}
      {message && (
        <Text
          accessibilityElementsHidden
          aria-hidden
          importantForAccessibility='no-hide-descendants'
          className='color-white/75'
          size='md'
        >
          {message}
        </Text>
      )}
    </VStack>
  </VStack>
)
